import './policy.css';
import { Header } from "../../components/widgets/header/header";
import { smoothScroll } from "../index/smooth-scroll";

export function initPolicyPage() {
  Header.init();
  smoothScroll.init();
}